import {ampProperties} from '@edume/bento/amplitude';

import {logEvent} from '../logEvent';
import type {EDUME_LIBRARY, GROUP_LIBRARY} from '../trackingProps';
import {SEARCHED_MEDIA} from '../trackingProps';

const {
  COURSE_ID,
  GUIDE_ID,
  LESSON_ID,
  SEARCH_TERM,
  NUMBER_OF_RESULTS_RETURNED,
  SOURCE,
} = ampProperties;

export const sendSearchedMediaEvent = ({
  courseId,
  lessonId,
  guideId,
  searchQuery,
  numberOfResults,
  source,
}: {
  courseId?: number;
  lessonId?: number;
  guideId?: number | string | null;
  searchQuery: string;
  numberOfResults: number;
  source: typeof EDUME_LIBRARY | typeof GROUP_LIBRARY;
}) => {
  const eventProps: {[key: string]: string | number} = {
    [SEARCH_TERM]: searchQuery,
    [NUMBER_OF_RESULTS_RETURNED]: numberOfResults,
    [SOURCE]: source,
  };

  if (courseId) {
    eventProps[COURSE_ID] = courseId;
  }

  if (lessonId) {
    eventProps[LESSON_ID] = lessonId;
  }

  if (guideId) {
    eventProps[GUIDE_ID] = guideId;
  }

  logEvent(SEARCHED_MEDIA, eventProps);
};
